import React from "react";

import "./Artwork.css";

type Props = {
  token: string;
};

const SIZE = 250;

const Artwork: React.FC<Props> = (props) => {
  const { token } = props;

  return (
    <div className="artwork">
      <img
        style={{ width: SIZE, height: SIZE }}
        src={`https://ipfs.io/ipfs/QmQGVDe5GTGyKX2vcjyARemLYChimxfXvaptSTkDBQk26H/${token}.png`}
        alt={token}
      />
      <p>#{token}</p>
    </div>
  );
};

export default Artwork;
